module.exports = __webpack_public_path__ + "media/images/weather/rainy-271b2e22e2490b4406fb9801a90b2123.jpg";